module.exports = __webpack_public_path__ + "media/invite/plus-simple-c6ccf309.svg";